export default "__VITE_ASSET__CZvOg0b0__"